<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">Gauti duomenys</h3>

    <zurnalas-gaunami-search :loading="loading" @search="searchGaunami" />

    <v-data-table
      class="mb-4"
      :loading="loading"
      :headers="headers"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.zug_gavimo_data`]="{ item }">
        <div class="nowrap">{{ item.zug_gavimo_data_split.diena }}</div>
        <div class="nowrap">{{ item.zug_gavimo_data_split.laikas }}</div>
      </template>
      <template #[`item.zug_busenos_data`]="{ item }">
        <div class="nowrap">{{ item.zug_busenos_data_split.diena }}</div>
        <div class="nowrap">{{ item.zug_busenos_data_split.laikas }}</div>
      </template>
      <template #[`item.zug_sutvarkyti_iki`]="{ item }">
        <div class="nowrap">{{ item.zug_sutvarkyti_iki }}</div>
      </template>
      <template #[`item.zug_busena`]="{ item }">
        <el-hipoteka-busena :busena="item.zug_busena" />
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @viewItem="editItem(item)"
            @viewArchyvasItem="archyvasItem(item)"
            @deleteItem="deleteItem(item)"
            @restoreItem="restoreItem(item)"
          />
        </div>
        <v-tooltip top v-if="item.zug_tikrina">
          <template v-slot:activator="{ on, attrs }">
            <v-chip small outlined class="mt-1 mb-1" v-bind="attrs" v-on="on">
              <div class="tikrina-chip text-truncate">
                Tikrina {{ item.zug_tikrina }}
              </div>
            </v-chip>
          </template>
          <div class="tooltip-text">
            Tikrina<br />
            {{ item.zug_tikrina }}
          </div>
        </v-tooltip>
        <v-tooltip top v-if="item.zug_grazinta_ntr">
          <template v-slot:activator="{ on, attrs }">
            <v-chip small outlined class="mt-1 mb-1" v-bind="attrs" v-on="on">
              <div class="tikrina-chip text-truncate">
                Grąžinta NTR
              </div>
            </v-chip>
          </template>
          <div class="tooltip-text">
            Grąžinta NTR
          </div>
        </v-tooltip>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template slot="loading">
        kraunasi
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-archyvas-bylos
      :title="archyvasTitle"
      :text="archyvasText"
      :bylos="archyvasBylos"
      v-model="showArchyvasBylos"
    />

    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="printData('zurnalasgaunami/print', 'Gauti duomenys')"
        :disabled="canPrint"
        :loading="loading"
        >Spausdinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipoteka/hipotekaMap'
import ZurnalasGaunamiSearch from './ZurnalasGaunamiSearch'
import print from '../../mixins/print'
import userRole from '../../mixins/userRole'
import ModalArchyvasBylos from '../modals/ModalArchyvasBylos'
import math from '../../mixins/math'

export default {
  name: 'ZurnalasGaunami',
  components: {
    ZurnalasGaunamiSearch,
    ModalArchyvasBylos,
  },
  mixins: [userRole, print, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      zurnalas_gaunami: [],
      searchData: {},
      headers: [
        {
          text: 'Registracijos numeris',
          align: 'start',
          value: 'zug_numeris',
        },
        {
          text: 'Gavimo data ir laikas',
          align: 'center',
          value: 'zug_gavimo_data',
        },
        {
          text: 'Pranešimo rūšis',
          align: 'start',
          value: 'hipotekaTipas',
        },
        {
          text: 'Duomenų teikėjo dokumento numeris',
          align: 'start',
          value: 'zug_dokumento_numeris',
        },
        {
          text: 'Identifikavimo kodas (IDK)',
          align: 'start',
          value: 'zug_identifikavimo_kodas',
        },
        {
          text: 'Duomenų teikėjas',
          align: 'start',
          value: 'zug_duomenu_teikejas',
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'zug_busena',
        },
        {
          text: 'Busenos data',
          align: 'center',
          value: 'zug_busenos_data',
        },
        {
          text: 'Sutvarkyti iki',
          align: 'center',
          value: 'zug_sutvarkyti_iki',
        },
        {
          text: 'Vykdytojas',
          align: 'start',
          value: 'zug_vykdytojas',
        },
        {
          text: 'Paskutinis veiksmus atlikęs asmuo',
          align: 'start',
          value: 'zug_atnaujino',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      lockInterval: null,
      lockTimeout: 10000,

      archyvasTitle: null,
      archyvasText: null,
      archyvasBylos: [],
      showArchyvasBylos: false,
    }
  },
  computed: {
    ...mapGetters(['getLockObjId', 'listInfo']),

    filterItemList() {
      return this.zurnalas_gaunami.map(item => {
        item.hipotekaTipas = HipotekaMap['hipotekaTipas'][item.zug_obj_tipas]
          ? HipotekaMap['hipotekaTipas'][item.zug_obj_tipas].title
          : item.zug_obj_tipas

        let hipoteka_veiksmas = ''
        if (item.obj_veiksmas === 1) {
          hipoteka_veiksmas = ' (sudarymas)'
        }
        if (item.obj_veiksmas === 2) {
          hipoteka_veiksmas = ' (teikimas)'
        }
        if (item.obj_veiksmas === 3) {
          hipoteka_veiksmas = ' (perleidimas)'
        }
        item.hipotekaTipas += hipoteka_veiksmas

        item.zug_gavimo_data_split = this.splitDate(item.zug_gavimo_data)
        item.zug_busenos_data_split = this.splitDate(item.zug_busenos_data)

        if (item.zug_uzrakinta) {
          item.canLock = true
          item.lockMsg = item.zug_uzrakines_asmuo
        } else {
          item.canEdit =
            (item.zug_busena === 'perduotas' ||
              item.zug_busena === 'grazintas') &&
            !this.role('RG_NTR_vadovas')
          item.canView = !item.canEdit
        }
        if (item.zug_pasirasymas_vadovas) {
          if (
            (this.roleDT && item.zug_busena_tolimesne === 'perduotas') ||
            (this.roleRGV && item.zug_busena_tolimesne === 'atmestas') ||
            (this.roleRGV && item.zug_busena_tolimesne === 'grazintas')
          ) {
            item.showSign = true
          }

          if (this.role('RG_NTR_vadovas') && !item.zug_uzrakinta) {
            item.canEdit = true
            item.canView = false
          }

          if (
            item.zug_busena === 'perduotas' &&
            !this.role('RG_NTR_vadovas') &&
            !item.zug_uzrakinta
          ) {
            item.canView = true
            item.canEdit = false
            item.canDelete = false
          }
        }
        if (item.laukia_patvirtinimo) {
          item.canEdit = false
          item.canDelete = false
          item.canView = true
          item.showConfirm = true
          item.showConfirmText = `Laukia ${item.zug_registratoriai_aktyvus} patvirtinimo`
        }
        if (!item.obj_id) {
          item.canView = false
        }
        if (item.archyvinis) {
          item.canViewArchyvas = true

          item.bylos = item.bylos.map(byla => {
            return {
              ...byla,
              byl_url: `byla/${byla.byl_id}/${byla.byl_hash}/content`,
              byl_tipas: 'archyvas',
            }
          })
        }

        if (this.roleSkaitytojas) {
          item.canEdit = false
          item.canView = true
          item.canDelete = false
        }

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
    isLocked() {
      return this.zurnalas_gaunami.filter(item => item.zug_uzrakinta).length > 0
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
  created() {
    //
  },
  methods: {
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`zurnalasgaunami`, data)
        .then(res => {
          this.zurnalas_gaunami = res.data.zurnalas_gaunami
          this.pagination = { ...this.pagination, ...res.data.pagination }
          this.checkLoading()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchGaunami(searchData) {
      this.searchData = searchData
      this.loading = true

      let resetPageNr = true
      if (this.$route.params.toList) {
        this.pagination = this.listInfo.pagination
        resetPageNr = false
        this.$route.params.toList = false
      }
      this.getData(resetPageNr)
    },
    checkLoading() {
      if (this.isLocked) {
        if (!this.lockInterval) {
          this.lockInterval = setInterval(() => {
            this.getData()
          }, this.lockTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.lockInterval)
    },
    editItem(item) {
      const objektasID = item.obj_id
      this.$store.dispatch('objektasID', objektasID)
      this.$store.dispatch('hipotekaTipas', item.zug_obj_tipas)
      const listInfo = {
        obj_id: item.obj_id,
        routeName: 'zurnalasGaunami',
        pagination: this.pagination,
        search: this.searchData,
      }
      this.$store.dispatch('listInfo', listInfo).then(
        this.$router.push({
          name: 'hipotekaRegistravimas',
          params: {
            objektasID: objektasID,
          },
        })
      )
    },
    archyvasItem(item) {
      this.archyvasTitle = 'Archyviniai dokumentai'
      this.archyvasText =
        'Gauti dokumentai susiję su archyvine hipoteka / įkeitimu iš HR'
      this.archyvasBylos = item.bylos
      this.showArchyvasBylos = true
    },
    rowClass(item) {
      if (item.zug_busena === 'nepatikslintas') {
        return `zurnalas-outdate`
      }
      if (item.zug_sutvarkyti_status === 'warning') {
        return `zurnalas-warning`
      }
      if (item.zug_sutvarkyti_status === 'outdate') {
        return `zurnalas-outdate`
      }
      if (item.zug_sutvarkyti_status === 'repost') {
        return `zurnalas-repost`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
